var drukproef = {
    submitDrukproef: function(){
        if ($('#voorwaarden:checked').length === 0){
            $.fancybox('<h2>Algemene voorwaarden</h2><p>Je dient akkoord te gaan met de algemene voorwaarden</p>');
            alert('hier');
            return false;
        } else {
            $.fancybox.showLoading();
            $('#betaalmethode_id').val($('.betaal-list li.active').attr('data-id'));
            $('#submit-drukproef').hide();
            $('#form-drukproef').submit();
        }
    },
    refreshYourInfo: function(){
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            data: {'do' : 'showComponent', 'module' : 'producten', 'args[naam]' : 'DrukproefUwGegevens'},
            success: function(data){
                window.location.reload();
            }
        })
    }
}

$(function(){
    $('#submit-drukproef').click(function(){
        drukproef.submitDrukproef();
        return false;
    });
})